module.exports = __webpack_public_path__ + "static/media/BudgetSmartFull.2ad01bf3.svg";